// components/use-case-details/use-case-workflow/use-case-workflow-key-benefits-card.tsx
"use client";
// components/use-case-details/use-case-workflow/key-benefits-card.tsx

import { CheckCircle } from 'lucide-react'; // Or your chosen icon library
import React from 'react';

import { getColorClass, getTextColorClass } from '@/utils/tailwind';

interface UseCaseKeyBenefitsCardProps {
    title: string;
    benefits: { icon: string; title: string; description: string }[];
    iconColor?: string | number;
}

const UseCaseKeyBenefitsCard: React.FC<UseCaseKeyBenefitsCardProps> = ({ title, benefits, iconColor = "green" }) => {

    const getIconComponent = (iconName: string) => {
        switch (iconName) {
            case "CheckCircle":
                return <CheckCircle className={`${getColorClass(iconColor as string, "500")} mr-2 mt-0.5 flex-shrink-0`} size={20} />;

            // Add other icon cases as needed (e.g., for different benefit types)
            default:
                return null; // Or a default icon
        }
    };

    return (
        <div className="bg-gray-800 rounded-lg p-6 shadow-md">
            <h4 className={`text-lg font-bold mb-4 ${getTextColorClass('white')}`}>{title}</h4>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {benefits.map((benefit, index) => (
                    <li key={index} className="flex items-start">
                        {getIconComponent(benefit.icon)}
                        <div>
                            <span className={`font-bold ${getTextColorClass('white')}`}>{benefit.title}</span>
                            <p className={`text-sm ${getTextColorClass('gray', '300')}`}>{benefit.description}</p>

                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default UseCaseKeyBenefitsCard;